<app-card-table
    translatePrefix="workplace."
    [tableTitle]="'workplace.title'"
    [columns]="columns"
    [gridData]="$any(store.data.workplaces$ | async)"
    (createCallback)="goToDetail()"
    (detailCallback)="goToDetail($event)"
    (deleteCallbackWithEvent)="delete($event)"
    [refreshCallback]="store.api.getWorkplaces"
    [defaultSorters]="[{ column: 'id', direction: 'DESC' }]"
    [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [(store.serviceId || 0).toString()] }]]"
>
    <ng-template pTemplate="address" let-data="data">
        @if (data) {
            <span>
                <app-map-link-tag
                    [address]="data"
                    tooltip="database.organizationAdministrationPage.addresses.table.showOnMapButtonTitle"
                ></app-map-link-tag>
                {{ data.name + ', ' + data.location }}
            </span>
        }
    </ng-template>
</app-card-table>
